import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '../auth/SessionContext.jsx';
import { LogOut, Map as MapIcon, List as ListIcon, Home, Settings, ClipboardList, BarChart3, Gauge } from 'lucide-react';

export default function Header() {
  const { session, logout } = useSession();
  const nav = useNavigate();
  const loc = useLocation();

  if (!session) return null;

  const onLogout = async () => {
    await logout();
    nav('/login', { replace: true });
  };

  const label =
    session.role === 'admin'
      ? 'Vertuoso — Admin'
      : `Vertuoso — ${session.client_name || 'Client'}`;

  const isActive = (p) => (loc.pathname === p ? 'header__link--active' : '');

  return (
    <header className="header">
      <div className="header__bar">
        <Link to="/" className="header__brand" aria-label="Accueil">
          <img src="/logo.png" alt="" onError={(e) => { e.currentTarget.src = '/logo-placeholder.svg'; }} className="header__logo" />
          <span className="header__title">{label}</span>
        </Link>
        <button className="header__btn" onClick={onLogout} aria-label="Déconnexion" title="Déconnexion">
          <LogOut size={20} />
        </button>
      </div>
      <nav className="header__nav" aria-label="Navigation">
        <Link to="/" className={`header__link ${isActive('/')}`}><Home size={18}/><span>Accueil</span></Link>
        <Link to="/map" className={`header__link ${isActive('/map')}`}><MapIcon size={18}/><span>Carte</span></Link>
        <Link to="/list" className={`header__link ${isActive('/list')}`}><ListIcon size={18}/><span>Liste</span></Link>
        {session.role === 'admin' && (
          <>
            <Link to="/admin/codes" className={`header__link ${isActive('/admin/codes')}`}><Settings size={18}/><span>Codes</span></Link>
            <Link to="/admin/survey" className={`header__link ${isActive('/admin/survey')}`}><ClipboardList size={18}/><span>Questions</span></Link>
            <Link to="/admin/stats" className={`header__link ${isActive('/admin/stats')}`}><BarChart3 size={18}/><span>Stats</span></Link>
            <Link to="/admin/gestion" className={`header__link ${isActive('/admin/gestion')}`}><Gauge size={18}/><span>Gestion</span></Link>
          </>
        )}
      </nav>
      <style>{`
        .header { position: sticky; top: 0; z-index: 100; background: var(--vrt-navy); color: #fff; }
        .header__bar { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; gap: 12px; }
        .header__brand { display: flex; align-items: center; gap: 10px; color: inherit; text-decoration: none; min-width: 0; }
        .header__logo { height: 28px; width: auto; background: #fff; border-radius: 6px; padding: 4px; }
        .header__title { font-weight: 600; font-size: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .header__btn { background: transparent; border: 1px solid rgba(255,255,255,.25); color: #fff; border-radius: 8px; height: 36px; width: 36px; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .header__btn:hover { background: rgba(255,255,255,.1); }
        .header__nav { display: flex; gap: 4px; padding: 0 8px 8px; overflow-x: auto; }
        .header__link { display: inline-flex; align-items: center; gap: 6px; padding: 8px 12px; border-radius: 8px; color: rgba(255,255,255,.85); text-decoration: none; font-size: 13px; white-space: nowrap; }
        .header__link:hover { background: rgba(255,255,255,.1); color: #fff; }
        .header__link--active { background: var(--vrt-teal); color: #fff; }
      `}</style>
    </header>
  );
}
